import React from 'react';
import { connectQueryRules } from 'react-instantsearch-core';
import PanelCallbackHandler from '../components/PanelCallbackHandler';
import QueryRuleCustomData from '../components/QueryRuleCustomData';

var QueryRuleCustomDataWidget = function QueryRuleCustomDataWidget(props) {
  return /*#__PURE__*/React.createElement(PanelCallbackHandler, props, /*#__PURE__*/React.createElement(QueryRuleCustomData, props));
};

export default connectQueryRules(QueryRuleCustomDataWidget);